<template>
  <form @submit.prevent="onSearch" v-if="coachDropdown && coachDropdown.length">
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="monthDropdown && monthDropdown.length">
          <SelectVue
              v-model="filters.month"
              :options="monthDropdown"
              :is-clear="true"
              :placeholder="$t('general.month')"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="yearDropdown && yearDropdown.length">
          <SelectVue
              v-model="filters.year"
              :options="yearDropdown"
              :placeholder="$t('general.year')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
          <SelectVue
              v-model="filters.coachId"
              :options="coachDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.coach')" />
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  monthDropdown: {
    type: Array,
    required: true,
  },
  yearDropdown: {
    type: Array,
    required: true,
  },
  coachDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit        = defineEmits([ 'search' ]);
const { filters } = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped>
</style>
